exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ---------- COLORS ----------*/\n.shrinkLabel span {\n  margin-left: -10px;\n}\n", ""]);

// exports
